export const Input = ({
  type = "text",
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  isFocused = false,
  className = "",
  prefix,
  suffix,
  width,
  textAlign,
  ...props
}) => {
  const inputStyles = {
    width: width || "100%",
    textAlign: textAlign || "left",
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    boxSizing: "border-box",
    outline: "none",
    ...(isFocused && {
      borderColor: "#F97316",
      boxShadow: "0 0 0 2px rgba(249, 115, 22, 0.2)",
    }),
  };

  const wrapperStyles = {
    position: "relative",
    width: "100%",
  };

  const prefixStyles = {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
    pointerEvents: "none",
  };

  const suffixStyles = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
    pointerEvents: "none",
  };

  const inputWithAffixStyles = {
    ...inputStyles,
    padding: prefix
      ? "8px 12px 8px 28px"
      : suffix
        ? "8px 28px 8px 12px"
        : "8px 12px",
  };

  if (prefix || suffix) {
    return (
      <div style={wrapperStyles}>
        {prefix && <span style={prefixStyles}>{prefix}</span>}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          style={inputWithAffixStyles}
          className={className}
          {...props}
        />
        {suffix && <span style={suffixStyles}>{suffix}</span>}
      </div>
    );
  }

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      style={inputStyles}
      className={className}
      {...props}
    />
  );
};
